export const ATTRIBUTE_MODELS = [
  { id: 0, key: 'CONVERSATION' },
  { id: 1, key: 'CONTACT' },
];

export const ATTRIBUTE_TYPES = [
  { id: 0, key: 'TEXT' },
  { id: 1, key: 'NUMBER' },
  { id: 2, key: 'CURRENCY' },
  { id: 3, key: 'PERCENT' },
  { id: 4, key: 'LINK' },
  { id: 5, key: 'DATE' },
  { id: 6, key: 'LIST' },
  { id: 7, key: 'CHECKBOX' },
  { id: 8, key: 'DATETIME' },
  { id: 9, key: 'MULTI_LIST' },
];

export const FORMULA_OPS = [
  { id: 'sum', key: 'SUM' },
  { id: 'avg', key: 'AVG' },
  { id: 'count', key: 'COUNT' },
];
